import React from 'react';
import img2 from '../../../images/Gallery/ambulance.jpg';
import img3 from '../../../images/Gallery/pharmacy.jpg';
import img4 from '../../../images/Gallery/sonogram.jpg';
import img5 from '../../../images/Gallery/ambulance2.jpg';
import img6 from '../../../images/Gallery/privateroom.jpg';
import img7 from '../../../images/Gallery/xrayroom.jpg';
import img8 from '../../../images/Gallery/laboratory.jpg';
import img9 from '../../../images/Gallery/beds.jpg';
import './index.css';
import { Image } from 'antd';

const Gallery = () => {
    const imageArray = [img2,img3,img4,img5,img6,img7, img8, img9]
    const imageNames = ['Ambulance', 'Pharmacy', 'Sonogram', 'Ambulance', 'Private Room', 'X-ray Room', 'Laboratory', 'Beds'];

    return (
        <section className="gallery container">
            <div className="text-center mb-5">
                <div className="section-title mb-3">
                    <h2>Gallery</h2>
                    <p>Explore WRCHospital essence through our gallery, showcasing our dedication to exceptional care.</p>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row g-0">
                    <Image.PreviewGroup>
                        {
                            imageArray.map((item, index) => (
                                <div className="col-lg-3 col-md-4 col-sm-12" key={index + 55}>
                                    <div className="gallery-item position-relative">
                                        <div className="galelry-lightbox d-flex justify-content-center align-items-center">
                                            <Image src={item} alt="" className="w-100" style={{objectFit:'cover',maxHeight:'280px', minHeight:'280px'}}/>
                                            <div className="image-name-overlay position-absolute bottom-0 start-50 translate-middle-x">
                                                <p className="m-0">{imageNames[index]}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </Image.PreviewGroup>
                </div>

            </div>
        </section>
    )
}

export default Gallery;
